import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpAccountsQueuePage } from '@/features/pcmp/pages/PcmpAccountsQueuePage';
import { pcmpAccountsQueueSearchSchema } from '@/features/pcmp/types/pcmpAccounts.types';

export const Route = createFileRoute('/_auth/pcmp/accounts/')({
  validateSearch: pcmpAccountsQueueSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Accounts">
      <Suspense fallback={<PageLoader />}>
        <PcmpAccountsQueuePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
